export * from './crm-save-delivery-point.endpoint';
export * from './crm-delete-delivery-point.endpoint';
export * from './crm-update-delivery-point.endpoint';
export * from './crm-find-delivery-point.endpoint';
export * from './crm-get-delivery-point.endpoint';
